import React from 'react';

import { NOTIFICATION_TYPE_OPTIONS } from '@vlabs/api-bindings/src/constants';
import validate from '@vlabs/shared/validators';
import { Control, SettingsItemWrapper } from '@vlabs/uikit';
import cn from 'classnames';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import st from './SharedFormStyles.module.sass';

export function NotificationTypeSubForm() {
  const { t } = useTranslation();
  const {
    formState: { errors },
    register,
    control,
    notificationId,
    needVA,
  } = useFormContext();

  return (
    <div className={st.NotificationFormBlock}>
      <h6>{t('vlNotifier:general')}</h6>
      <div>
        <SettingsItemWrapper
          className={cn(st.CustomSettingsItemWrapper, {
            [st.CustomSettingsItemWrapper_edit]: !needVA || notificationId !== 'create',
          })}
          contentClassName={st.Content}
          title={t('name')}
          titleClassName={st.Title}
        >
          <Control.Input
            {...register('filters.name', {
              required: validate.required(),
            })}
            errors={errors}
          />
        </SettingsItemWrapper>
        {!!needVA && notificationId === 'create' && (
          <SettingsItemWrapper
            className={st.CustomSettingsItemWrapper}
            contentClassName={st.Content}
            title={t('vlNotifier:filters.events_type')}
            titleClassName={st.Title}
          >
            <Control.Select
              control={control}
              name="filters.type"
              options={NOTIFICATION_TYPE_OPTIONS.raw}
            />
          </SettingsItemWrapper>
        )}
      </div>
    </div>
  );
}
